import { ErrorBoundary } from '@libs/templates/template-pages';
import { Route } from 'react-router';
import { AiLayout } from './layouts/AiLayout';

export const aiRouter = (
  <Route path="/ai" element={<AiLayout />} errorElement={<ErrorBoundary />}>
    <Route path="hub" lazy={async () => import('./pages/AiHub')} />
  </Route>
);
